<script lang="ts">
  import { currentLanguage } from '$lib/i18n/store';
  import { browser } from '$app/environment';

  let { data, children } = $props();

  // Update the current language store and html lang attribute
  $effect(() => {
    if (data.lang) {
      currentLanguage.set(data.lang);
      if (browser) {
        document.documentElement.lang = data.lang;
      }
    }
  });

  const localeMap: Record<string, string> = {
    de: 'de_CH',
    en: 'en_US',
    fr: 'fr_CH',
    it: 'it_CH'
  };
</script>

<svelte:head>
  <meta property="og:locale" content={localeMap[data.lang] || 'de_CH'} />
</svelte:head>

{@render children()}
